module.exports = __webpack_public_path__ + "img/hr-V-L-6-unload-connect.b8af52ee.png";